import { forwardRef, useState, useEffect } from 'react';
import DirectInput from '../../../../../../components/directInput/DirectInput';
import DropdownReg from '../../../../../../components/dropdownReg/DropdownReg';
import { fetchTypesData } from './fetchTypes/FetchTypes';
import './quickView.css';
import useSectionHighlightRef from '../../../../../../hooks/useSectionHighlightRef';
import Autocomplete from '../../../../../../components/reusable-ui-components/autoCompleteSearch/Autocomplete';
import { fetchDropdowns } from '../../../../../supDropdown/dropdownFun/dropdownCRUD';
import MultiSelect from '../../../../../../components/multiselect/multiselect';

const QuickView = forwardRef(({ formData, setFormData }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    const diffDrop = ['Easy', 'Medium', 'Difficulty'];
    const foodDrop = ['Veg', 'Non-veg', 'Veg & Non-veg'];
    const [typeSel, setTypeSel] = useState('camp');
    // const [typesData, setTypesData] = useState([]);
    const [dropdownData, setDropdownData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchDropdowns(setDropdownData, setLoading, 0, 10, 'camp', 'dropdown', 'active');
    }, []);

    const baseCitiesData = dropdownData.find((item) => item.heading === 'Base Cities')?.dropdown;
    const typesData = dropdownData.find((item) => item.heading === 'Amenities')?.dropdown;
    // useEffect(() => {
    //     fetchTypesData(typeSel, 'Types', setTypesData);
    // }, [typeSel]);

    useEffect(() => {
        setTypeSel((prev) => prev);
    }, []);
    console.log(dropdownData, typesData);
    return (
        <div ref={sectionRef}>
            <h2 className='orgPackUpH2'>Quick View</h2>
            <div className='orgPackUpSecDiv' style={{ padding: '10px 5%' }}>
                {/* <MultiSelect
                    label='Type / Category'
                    helperText='*Can select multiple types'
                    name='type'
                    value={formData.quickView?.type || []}
                    data={typesData}
                    listAll={true}
                    closeListOnItemSelect={false}
                    onChange={(val) => {
                        setFormData((prev) => ({
                            ...prev,
                            quickView: {
                                ...prev.quickView,
                                type: val
                            }
                        }));
                    }}
                    error={highlightField === 'type'}
                /> */}
                <DirectInput
                    label='Where'
                    name='where'
                    value={formData.quickView?.where}
                    type='text'
                    placeholder='Destination district. Ex - Chikamagluru'
                    setFormData={setFormData}
                    min={2}
                    limit={30}
                    nest='quickView'
                    error={highlightField === 'where'}
                />
                <DropdownReg
                    label='Food'
                    name={'food'}
                    options={foodDrop}
                    value={formData.quickView?.food}
                    req={true}
                    setFormData={setFormData}
                    nest='quickView'
                    error={highlightField === 'food'}
                />
                <div className='dropRegDiv'>
                    <label className={'dropRegLabel'}>Base Cities</label>
                    <Autocomplete
                        dropdownData={baseCitiesData || []}
                        selectedData={formData?.quickView?.baseCities || []}
                        onChange={(updatedArray) => {
                            setFormData((prev) => ({
                                ...prev,
                                quickView: {
                                    ...prev.quickView,
                                    baseCities: updatedArray
                                }
                            }));
                        }}
                        multiSelect={false}
                        placeholder={'Search base cities'}
                    />
                </div>
                <DirectInput
                    label='Area'
                    name='area'
                    value={formData.quickView?.area}
                    type='text'
                    placeholder='Destination Area. Ex - Kengeri'
                    setFormData={setFormData}
                    min={2}
                    limit={30}
                    nest='quickView'
                    error={highlightField === 'area'}
                />
                <MultiSelect
                    label='Amenities'
                    helperText='*Can select multiple amenities'
                    name='amenities'
                    value={formData.quickView?.amenities || []}
                    data={typesData}
                    listAll={true}
                    closeListOnItemSelect={false}
                    onChange={(val) => {
                        setFormData((prev) => ({
                            ...prev,
                            quickView: {
                                ...prev.quickView,
                                amenities: val
                            }
                        }));
                    }}
                    error={highlightField === 'type'}
                />
            </div>
        </div>
    );
});

export default QuickView;
